import { $SpecialGradeLevel, SpecialGradeLevel } from '@suntex.fim/enums'

/**
 * Define and export options for all games enum
 */
export enum AllGamesOptions {
  summary = 'Summary',
  gym = 'Gyms',
  JTF = 'Just the Facts'
}

/**
 * Define and export title for AssessmentCumulativeTrendsChart enum
 */
export enum AssessmentCumulativeTrendsChartTitle {
  today = 'Today',
  stickers1D = '1 day ago',
  stickers2D = '2 days ago',
  stickers3D = '3 days ago',
  stickers4D = '4 days ago',
  stickers5D = '5 days ago',
  stickers6D = '6 days ago',
  thisWeek = 'This Week',
  stickers1W = '1 week ago',
  stickers2W = '2 week ago',
  stickers3W = '3 weeks ago',
  thisMonth = 'This Month',
  stickers1M = '1 Month ago',
  stickers2M = '2 Months ago',
  stickers3M = '3 Months ago',
  stickers4M = '4 Months ago'
}

/**
 * Define and export options for AddEditStudentFormGroup enum
 */
export enum AddEditStudentFormGroupOptions {
  '-' = '- (Unassigned)',
  A = 'A (Grades 4/5)',
  B = 'B (Grades 3/4)',
  C = 'C (Grades 4/5)',
  D = 'D (Grade 2)',
  E = 'E (Grade 3)',
  F = 'F (RTI Grade 1)',
  G = 'G (Grade 2 ASI)',
  H = 'H (Unassigned)',
  I = 'I (Unassigned)',
  J = 'J (Unassigned)',
  K = 'K (Unassigned)',
  L = 'L (Unassigned)',
  M = 'M (Unassigned)',
  N = 'N (Unassigned)',
  O = 'O (Unassigned)',
  P = 'P (Unassigned)'
}

/**
 * Define and export common options enum
 */
export enum CommonOptions {
  opt1 = 'option1',
  opt2 = 'option2',
  opt3 = 'option3'
}

/**
 * Define and export options for AssessmentReportMW enum
 */
export enum AssessmentReportMWOptions {
  'equal-weight' = 'Equal Weight',
  'equal-Length' = 'Equal Length',
  'time_more_or_less' = 'Time More Or Less',
  'equal_time' = 'Equal Time',
  'passing_time' = 'Passing Time',
  'equal_pay' = 'Equal Pay $',
  'equal_pay_india' = 'Equal Pay Rupees',
  'making_change' = 'Making Change',
  'making_change_india' = 'Making Change Rupees',
  'area_perimeter_square' = 'Area Square',
  'area_perimeter_circle' = 'Area Circle',
  'area_perimeter_triangle' = 'Area Triangle',
  'area_perimeter_rectangle' = 'Area Rectangle'
}

/**
 * Define and export options for AssessmentReportVIFSend enum
 */
export enum AssessmentReportVIFSendOptions {
  'addition' = 'Addition',
  'subtraction' = 'Subtraction',
  'multiplication' = 'Multiplication',
  'division' = 'Division'
}

/**
 * Define and export options for AssessmentReportSAView enum
 */
export const AssessmentReportSAViewOptions = {
  0: 'Sticker Counts',
  1: 'Trends By Intervals',
  2: 'Cumulative Trends'
}
/**
 * Define and export options for AssessmentReportSATrend enum
 */

export const AssessmentReportSATrendOptions = {
  0: 'Today',
  1: 'This Week'
}
/**
 * Define and export options for AssessmentReportVIFLevel enum
 */
export const AssessmentReportVIFLevelOptions = {
  0: 'Addition/Subtraction',
  1: 'Multiplication/Division',
  2: 'All Operations'
}
/**
 * Define and export options for EditTeamFormClass enum
 */
export const EditTeamFormClassOptions = {
  0: 'PK / Kindergarten',
  1: 'Grade 1',
  2: 'Grade 2',
  3: 'Grade 3',
  4: 'Grade 4',
  5: 'Grade 5',
  6: 'Grade 6',
  7: 'Grade 7',
  8: 'Grade 8',
  50: 'Other'
}

/**
 * Define and export Level options enum
 */
export const LevelOptions = {
  0: 'Early',
  1: 'Elementary',
  2: 'Intermediate'
}

/**
 * Define and export options for AssessmentReportEarly enum
 */
export const AssessmentReportEarlyOptions = {
  0: 'Pre-Kindergarten',
  1: 'K2: Shapes',
  2: 'K2: Numbers',
  3: 'K2: Computational Thinking',
  4: 'First In Reading: Letters',
  5: 'First In Reading: Words',
  6: 'First In Reading: Sentences'
}

export const AssessmentReportJTFWhenOptions = {
  0: 'Pre-Test',
  1: ' Current Post-Test'
}

/**
 * Define and export richTextFormats enum
 */
export const richTextFormats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video'
]

/**
 * Define and export options for TeamTopPlayersType enum
 */
export const TeamTopPlayersType = {
  0: 'All Time',
  1: 'Today',
  2: 'Yesterday',
  3: 'Week',
  4: 'Month'
}

/**
 * Define and export tablePageSize enum
 */
// eslint-disable-next-line no-magic-numbers
export const tablePageSize = [10, 25, 50, 75, 100]
